import {Button} from "../../Button";
import {LayerSticky} from "./Styled";
import React from "react";
import {BasicItem} from "../types";
import {useHistory} from "react-router";
import {RootStore} from "../../../../configureStore";
import {useSelector} from "react-redux";
interface Props<T extends BasicItem> {
    userSelectedItems: T[];
    closeMenu(): void;
    items: T[];
}
const SelectStickyDoneButton = function <T extends BasicItem>({
    closeMenu,
    userSelectedItems,
    items,
}: Props<T>): JSX.Element {
    const selectedItemCount = userSelectedItems.length;
    const isMobile = useSelector((state: RootStore) => state.layout.isMobile);

    const history = useHistory();
    return (
        <LayerSticky>
            {selectedItemCount > 0 && <span>{selectedItemCount} selected</span>}
            <Button
                onClick={() => {
                    isMobile ? history.goBack() : closeMenu();
                }}
                {...(items.length > 0 ? {orange: "orange"} : {disabled: "disabled"})}
            >
                OK
            </Button>
        </LayerSticky>
    );
};

export default SelectStickyDoneButton;
